import Vue from 'vue';

Vue.filter('seTimeFilter', function (value,sq) {//申请---开始时间和结束时间
    value = +value
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    if(sq=='sq'){
      return y + '年' + MM + '月' + d + '日 ' + h + ':' + m + ':' + s;
    }else if(sq=='s'){
      return y + '-' + MM + '-' + d;
    }else if(sq=='md'){
      return  MM + '-' + d;
    }else if(sq=='sjx'){
      return  y + '-' + MM + '-' + d + ' ' + h + ':' + m ;
    }else if(sq=='yr'){
        return MM + '-' + d
    }else if(sq=='n'){
      return y
    }
  });